<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'usuarios' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Lista de Usuários COM/SEM bloqueios
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-sheet color="white" elevation="1" rounded>
          <v-lazy>
            <div class="text-start py-2 px-4 text-button">Datas para bloqueios dos Bimestres</div>
          </v-lazy>
          <v-divider class="theme--light"></v-divider>
          <div class="py-2 px-3">
            <p class="">
              Defina as datas iniciais e finais dos bimestres e se deseja bloquear ou liberar
            </p>
            <v-row>
              <v-col cols="12" sm="3" xs="12">
                <e-label>1° Bimestre</e-label>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Inicial</label>
                </div>
                <v-dialog
                  ref="dialog_bim1_inicio"
                  v-model="modal_bim1_inicio"
                  :return-value.sync="data_bim1_inicio"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim1_inicio_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim1_inicio" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim1_inicio = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim1_inicio.save(data_bim1_inicio)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Final</label>
                </div>
                <v-dialog
                  ref="dialog_bim1_final"
                  v-model="modal_bim1_final"
                  :return-value.sync="data_bim1_final"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim1_final_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim1_final" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim1_final = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim1_final.save(data_bim1_final)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>

                <v-switch
                  v-model="bim1_bloquear"
                  :label="bim1_bloquear ? 'Bloqueado' : 'Liberado'"
                  @change="($event) => bloquearLiberar($event, 1)"
                ></v-switch>
              </v-col>

              <v-col cols="12" sm="3" xs="12">
                <e-label>2° Bimestre</e-label>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Inicial</label>
                </div>
                <v-dialog
                  ref="dialog_bim2_inicio"
                  v-model="modal_bim2_inicio"
                  :return-value.sync="data_bim2_inicio"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim2_inicio_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim2_inicio" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim2_inicio = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim2_inicio.save(data_bim2_inicio)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Final</label>
                </div>
                <v-dialog
                  ref="dialog_bim2_final"
                  v-model="modal_bim2_final"
                  :return-value.sync="data_bim2_final"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim2_final_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim2_final" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim2_final = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim2_final.save(data_bim2_final)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <v-switch
                  :label="bim2_bloquear ? 'Bloqueado' : 'Liberado'"
                  v-model="bim2_bloquear"
                  @change="($event) => bloquearLiberar($event, 2)"
                ></v-switch>
              </v-col>

              <v-col cols="12" sm="3" xs="12">
                <e-label>3° Bimestre</e-label>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Inicial</label>
                </div>
                <v-dialog
                  ref="dialog_bim3_inicio"
                  v-model="modal_bim3_inicio"
                  :return-value.sync="data_bim3_inicio"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim3_inicio_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim3_inicio" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim3_inicio = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim3_inicio.save(data_bim3_inicio)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Final</label>
                </div>
                <v-dialog
                  ref="dialog_bim3_final"
                  v-model="modal_bim3_final"
                  :return-value.sync="data_bim3_final"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim3_final_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim3_final" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim3_final = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim3_final.save(data_bim3_final)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <v-switch
                  :label="bim3_bloquear ? 'Bloqueado' : 'Liberado'"
                  v-model="bim3_bloquear"
                  @change="($event) => bloquearLiberar($event, 3)"
                ></v-switch>
              </v-col>

              <v-col cols="12" sm="3" xs="12">
                <e-label>4° Bimestre</e-label>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Inicial</label>
                </div>
                <v-dialog
                  ref="dialog_bim4_inicio"
                  v-model="modal_bim4_inicio"
                  :return-value.sync="data_bim4_inicio"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim4_inicio_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim4_inicio" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim4_inicio = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim4_inicio.save(data_bim4_inicio)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <div>
                  <label class="theme--light" style="font-size: 12px">Data Final</label>
                </div>
                <v-dialog
                  ref="dialog_bim4_final"
                  v-model="modal_bim4_final"
                  :return-value.sync="data_bim4_final"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data_bim4_final_fmt"
                      persistent-hint
                      label="Escolha uma data"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      solo
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="data_bim4_final" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="modal_bim4_final = false"> Cancel </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog_bim4_final.save(data_bim4_final)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
                <v-switch
                  :label="bim4_bloquear ? 'Bloqueado' : 'Liberado'"
                  v-model="bim4_bloquear"
                  @change="($event) => bloquearLiberar($event, 4)"
                ></v-switch>
              </v-col>
            </v-row>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet color="white" elevation="1" rounded>
          <v-lazy>
            <div class="text-start py-2 px-4 text-button">Seleção avançada</div>
          </v-lazy>
          <v-divider class="theme--light"></v-divider>
          <div class="py-2 px-3">
            <v-row
              style="cursor: pointer"
              @click="expand_bloqueio_geral = !expand_bloqueio_geral"
              class="py-2 cursor"
              justify="center"
            >
              <div class="text-start px-4 text-button">Bloqueio geral</div>
            </v-row>
            <ValidationObserver v-slot="{ handleSubmit }">
              <v-form @submit.prevent.stop="handleSubmit(submitForm)" :disabled="submittingForm">
                <v-expand-transition>
                  <div v-show="expand_bloqueio_geral">
                    <v-row>
                      <v-col cols="12" sm="7" xs="12">
                        <e-label>Escolha o(s) grupo</e-label>
                        <ValidationProvider
                          name="regras/grupos"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <e-autocomplete
                            :items="roles"
                            :return-object="false"
                            :error-messages="errors"
                            v-model="form.roles"
                            label="Selecione uma opção"
                            item-text="name"
                            item-value="id"
                            dense
                            solo
                            multiple
                          />
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="5" xs="12">
                        <e-label>Escolha o(s) situaçao</e-label>
                        <e-autocomplete
                          :items="$constants.situacoesUsuarios"
                          :return-object="false"
                          v-model="form.situacao"
                          item-text="descricao"
                          item-value="descricao"
                          label="Selecione uma opção"
                          dense
                          solo
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pt-0 pb-5">
                        <v-btn
                          color="primary"
                          :disabled="submittingForm"
                          :loading="submittingForm"
                          type="submit"
                          block
                          >Enviar Dados</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                </v-expand-transition>
              </v-form>
            </ValidationObserver>
          </div>
          <v-divider></v-divider>
          <div class="py-2 px-3">
            <v-row
              style="cursor: pointer"
              @click="expand_bloqueio_aulas_bime = !expand_bloqueio_aulas_bime"
              class="py-2 cursor"
              justify="center"
            >
              <div class="text-start px-4 text-button">Bloqueio de aulas e bimestres</div>
            </v-row>
            <v-expand-transition>
              <div class="px-5" v-show="expand_bloqueio_aulas_bime">
                <v-row class="mt-4">
                  <v-col cols="5">
                    <e-label>Escolha o(s) grupo</e-label>
                    <ValidationProvider name="regras/grupos" rules="required" v-slot="{ errors }">
                      <e-autocomplete
                        :items="roles"
                        :return-object="false"
                        :error-messages="errors"
                        v-model="form.grupos_bloqueados"
                        label="Selecione uma opção"
                        item-text="name"
                        item-value="id"
                        dense
                        solo
                        multiple
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="4">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="data_bloqueio"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Bloqueio de lançamento de aulas</e-label>
                        <v-text-field
                          v-model="form.data_bloqueio"
                          persistent-hint
                          label="Escolha uma data"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          solo
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="data_bloqueio" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(data_bloqueio)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-col class="pt-10 pb-0" cols="3">
                    <v-btn color="success" @click="data_bloqueio = ''">Limpar data</v-btn>
                  </v-col>
                </v-row>
                <div class="mb-5">
                  <v-divider></v-divider>
                </div>

                <!-- Bloqueio bimestral -->
                <v-row>
                  <v-col class="pt-0 pb-0" cols="6">
                    <e-label>Bloqueio de lançamento de planos</e-label>
                    <v-select
                      :items="$constants.bimestresBloqueio"
                      :return-object="false"
                      v-model="form.bimestres"
                      label="Selecione uma opção"
                      item-text="desc"
                      item-value="value"
                      dense
                      solo
                      multiple
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0 pb-5">
                    <v-btn color="primary" @click="() => submitFormAulas()" type="submit" block
                      >Enviar Dados</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-expand-transition>
          </div>

          <div>
            <v-divider></v-divider>
          </div>
          <v-col>
            <v-subheader
              >* Todos os membros pertencentes ao grupo sofrerá o mesmo impacto. Por isso preste
              atenção antes de executar a ação.</v-subheader
            >
            <v-subheader
              >* Para bloquear o lançamento de aulas e planos a SITUAÇÃO não precisa está como
              bloqueada, basta informar a data e o grupo.</v-subheader
            >
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          class="search-input"
          append-icon="mdi-magnify"
          label="Pesquisar..."
          solo
          dense
          single-line
          hide-details
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <template>
          <v-data-table
            v-model="selected"
            :headers="table.headers"
            :items="outrosUsuariosList"
            :single-select="singleSelect"
            hide-default-footer
            item-key="name"
            class="elevation-1"
          >
            <template v-slot:item.role_id="{ item }">
              <e-user-role :value="item" />
            </template>
            <template v-slot:item.situacao="{ item }">
              <e-user-situacao :value="item" />
            </template>
            <template v-slot:item.data_bloqueio="{ item }">
              <e-user-data-bloqueio :value="item" />
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip v-if="!item.estaDeletado" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    class="ml-1"
                    color="blue-grey lighten-3"
                    v-bind="attrs"
                    v-on="on"
                    @click="() => editarUsuario(item)"
                  >
                    <v-icon small>fa fa-edit </v-icon>
                  </v-btn>
                </template>
                <span>Editar usuario</span>
              </v-tooltip>
              <v-tooltip v-if="!item.estaDeletado" color="error" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    class="ml-1"
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    @click="() => deletarUsuario(item)"
                  >
                    <v-icon small>fa fa-trash </v-icon>
                  </v-btn>
                </template>
                <span>Apagar usuario</span>
              </v-tooltip>
              <v-tooltip v-if="item.estaDeletado" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    class="ml-1"
                    color="info"
                    v-bind="attrs"
                    v-on="on"
                    @click="() => recuperarUsuario(item)"
                  >
                    <v-icon small>fa fa-sync </v-icon>
                  </v-btn>
                </template>
                <span>Recuperar usuario</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <e-paginate
            :current_page="paginate.current_page"
            :last_page="paginate.last_page"
            :pageNumber="pageNumber"
            @changeActionResponse="carregarUsuarios"
            :search="search"
          ></e-paginate>
        </template>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import Usuario from "../../Models/User";

export default {
  props: {},
  mounted() {
    this.carregandoUsuarios = true;
    this.$loaderService.open("Carregando Usuarios");
    this.carregarUsuarios(this.pageNumber);
    this.carregandoUsuarios = false;
    this.$loaderService.close();
    this.getRoles();
    this.getBimestresBloqueios();
  },
  data() {
    return {
      isLoading: false,
      bim1_bloquear: false,
      bim2_bloquear: false,
      bim3_bloquear: false,
      bim4_bloquear: false,
      bimestre1_data_inicial: null,
      bimestre1_data_final: null,
      bimestres: {
        bim1_inicio: null,
        bim1_fim: null,
        bim2_inicio: null,
        bim2_fim: null,
        bim3_inicio: null,
        bim3_fim: null,
        bim4_inicio: null,
        bim4_fim: null,
      },
      modalData: false,
      data: null,
      data_inicial_bim1: null,
      data_final_bim1: null,
      submittingForm: false,
      expand_bloqueio_geral: false,
      expand_bloqueio_aulas_bime: false,
      form: {
        situacao: null,
        grupos_bloqueados: [],
        data_bloqueio: null,
        bimestres: [],
      },
      roles: [],
      selected: [],
      singleSelect: false,
      usuarios: [],
      carregandoUsuarios: false,
      usuariosLoaded: false,
      usuariosList: [],
      outrosUsuariosList: [],
      dataTableFilter,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Nome", value: "name" },
          { text: "Login de acesso", value: "email" },
          { text: "Perfil", value: "role_id" },
          { text: "Situação", value: "situacao" },
          { text: "Data bloqueio", value: "data_bloqueio" },
          { text: "Ações", value: "actions", sortable: false },
        ],
      },
      check: false,
      data_bloqueio: null,
      modal: false,
      modal_bim1_inicio: false,
      grupos_bloqueados: [],
      data_bim1_inicio: null,
      data_bim1_inicio_fmt: null,
      data_bim1_final: null,
      data_bim1_final_fmt: null,
      data_bim2_inicio: null,
      data_bim2_inicio_fmt: null,
      data_bim2_final: null,
      data_bim2_final_fmt: null,
      data_bim3_inicio: null,
      data_bim3_inicio_fmt: null,
      data_bim3_final: null,
      data_bim3_final_fmt: null,
      data_bim4_inicio: null,
      data_bim4_inicio_fmt: null,
      data_bim4_final: null,
      data_bim4_final_fmt: null,
      modal_bim2_inicio: false,
      modal_bim3_inicio: false,
      modal_bim4_inicio: false,
      modal_bim1_final: false,
      modal_bim2_final: false,
      modal_bim3_final: false,
      modal_bim4_final: false,
    };
  },
  watch: {
    data(value) {
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.bimestre1_data_inicial = data_old.replaceAll("/", "/");
    },
    carregandoUsuarios(value) {
      if (value && this.outrosUsuariosList.length === 0) {
        this.$loaderService.open("Carregando usuarios");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 1) {
        await this.carregarUsuarios(0, val);
      }
      if (!val) {
        await this.carregarUsuarios(0);
      }
    },
    data_bloqueio(value) {
      if (!value) {
        this.form.data_bloqueio = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.form.data_bloqueio = data_old.replaceAll("/", "/");
    },
    data_bim1_inicio(value) {
      if (!value) {
        this.data_bim1_inicio_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim1_inicio_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_inicial: value,
      };
      this.saveBimestreData(1, data);
    },
    data_bim1_final(value) {
      if (!value) {
        this.data_bim1_final_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim1_final_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_final: value,
      };
      this.saveBimestreData(1, data);
    },
    data_bim2_inicio(value) {
      if (!value) {
        this.data_bim2_inicio_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim2_inicio_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_inicial: value,
      };
      this.saveBimestreData(2, data);
    },
    data_bim2_final(value) {
      if (!value) {
        this.data_bim2_final_fmt = null;
        return;
      }

      // 🔹 sempre formata para exibir
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim2_final_fmt = data_old;

      // 🔹 só salva no backend quando não está carregando
      if (this.isLoading) return;

      const data = { data_final: value };
      this.saveBimestreData(2, data);
    },
    data_bim3_inicio(value) {
      if (!value) {
        this.data_bim3_inicio_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim3_inicio_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_inicial: value,
      };
      this.saveBimestreData(3, data);
    },
    data_bim3_final(value) {
      if (!value) {
        this.data_bim3_final_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim3_final_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_final: value,
      };
      this.saveBimestreData(3, data);
    },
    data_bim4_inicio(value) {
      if (!value) {
        this.data_bim4_inicio_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim4_inicio_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_inicial: value,
      };
      this.saveBimestreData(4, data);
    },
    data_bim4_final(value) {
      if (!value) {
        this.data_bim4_final_fmt = value;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.data_bim4_final_fmt = data_old.replaceAll("/", "/");
      if (!value || this.isLoading) return;
      const data = {
        data_final: value,
      };
      this.saveBimestreData(4, data);
    },
  },
  methods: {
    async bloquearLiberar(situacao, id) {
      this.$toast.warn("Tentando atualizar os dados, aguarde!");
      try {
        const status = {
          status: situacao === false ? 0 : 1,
        };
        await this.$services.usuariosService.bloquearLiberarBimestre({ id, status });
        this.$toast.success("Bimestre atualizado com sucesso");
      } catch (error) {
        this.$handleError(error);
      }
    },
    async getBimestresBloqueios() {
      this.isLoading = true;
      try {
        const data = await this.$services.usuariosService.getBimestresDisponiveis();

        // seta no formato aceito pelo v-date-picker (YYYY-MM-DD)
        this.data_bim1_inicio = data.find((item) => item.id === 1).data_inicial;
        this.data_bim1_final = data.find((item) => item.id === 1).data_final;
        this.bim1_bloquear = data.find((item) => item.id === 1).status === 1;
        this.data_bim2_inicio = data.find((item) => item.id === 2).data_inicial;
        this.data_bim2_final = data.find((item) => item.id === 2).data_final;
        this.bim2_bloquear = data.find((item) => item.id === 2).status === 1;
        this.data_bim3_inicio = data.find((item) => item.id === 3).data_inicial;
        this.data_bim3_final = data.find((item) => item.id === 3).data_final;
        this.bim3_bloquear = data.find((item) => item.id === 3).status === 1;
        this.data_bim4_inicio = data.find((item) => item.id === 4).data_inicial;
        this.data_bim4_final = data.find((item) => item.id === 4).data_final;
        this.bim4_bloquear = data.find((item) => item.id === 4).status === 1;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async saveBimestreData(bimId, value) {
      // this.$toast.warn("Tentando atualizar os dados, aguarde...");
      try {
        await this.$services.usuariosService.saveBimestres({
          bimId,
          value,
        });
        // this.$toast.success("Datas dos bimestres atualizadas com sucesso");
      } catch (error) {
        this.$handleError(error);
      }
    },
    validate() {
      this.$refs.form.validate();
    },
    async submitForm() {
      this.$toast.warn("Tentando atualizar os dados, aguarde!");
      this.submittingForm = true;
      try {
        await this.$services.rolesService.allUsers(this.form);
        this.$toast.success("Usuario(s) atualizado(s) com sucesso");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
    async submitFormAulas() {
      this.$toast.warn("Tentando atualizar os dados, aguarde!");
      this.submittingForm = true;
      if (this.form.data_bloqueio) {
        this.form.data_bloqueio = this.form.data_bloqueio.split("/").reverse().join("-");
      }
      try {
        await this.$services.rolesService.allUsersData(this.form);
        this.$toast.success("Usuario(s) atualizado(s) com sucesso");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.submittingForm = false;
      }
    },
    async getRoles() {
      try {
        const response = await this.$services.rolesService.syncAll();
        this.roles = response.roles;
        this.data_bloqueio = response.data.data_bloqueio.data_bloqueio;
        this.form.grupos_bloqueados = response.data.data_bloqueio.roles;
        this.form.bimestres = response.data.data_bloqueio.bimestres;

        return;
      } catch (error) {
        this.$handleError(error);
      }
    },
    addSelect(usuario) {
      if (!this.usuarioInseridoNoSelected(usuario)) {
        this.selected.push(usuario);
      }
    },
    editarUsuario(usuario) {
      this.$router.push({ name: "usuarios.edit", params: { usuario_id: usuario.id } });
    },
    async deletarUsuario(usuario) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta usuario?",
        confirmationCode: usuario.id,
        confirmationMessage: `Por favor, digite <strong>${usuario.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Usuario");
              try {
                await this.$services.usuariosService.deletarUsuario(usuario);
                this.$toast.success("Usuário(a) Deletado(a) com sucesso");
                this.$forceUpdate();
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    recuperarUsuario(usuario) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta usuario?",
        confirmationCode: usuario.id,
        confirmationMessage: `Por favor, digite <strong>${usuario.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Usuario");
              try {
                await this.$services.usuariosService.recuperarUsuario(usuario);
                this.$toast.success("Usuario recuperada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
    async carregarUsuarios(pageNumber, query = null) {
      try {
        const response = await this.$services.usuariosService.syncAllPaginate(pageNumber, query);
        this.paginate = response.data;
        const usuarios = response.data.data.map((usuario) => new Usuario(usuario));
        this.outrosUsuariosList = usuarios;
      } catch (error) {
        this.$handleError(error);
      }
    },
  },
};
</script>

<style>
.cursor:hover {
  background: #faf7f7 !important;
}
</style>
